import React from "react";
import { FileSpreadsheet } from "lucide-react";

const ExportDataButton = ({ onClick, label = "Export", className = "" }) => {
  return (
    <button 
      onClick={onClick}
      className={`flex items-center justify-center gap-2 py-3 bg-emerald-600 hover:bg-emerald-700 text-white rounded-xl text-[10px] font-black uppercase tracking-widest transition-all active:scale-95 shadow-lg shadow-emerald-600/20 ${className}`}
    >
      <FileSpreadsheet size={18} /> {label}
    </button>
  );
};

export default ExportDataButton;